module.exports = __webpack_public_path__ + "img/2281.9e020614.png";